<script setup lang="ts">
import { reactive } from 'vue';
import { useModalStore } from '../../ui/modal/modal-store';
import type { PromptModalOptions } from '../../ui/modal/types';
import type { EmptyCallback, ParamsCallback } from '../../utils/global-types';

const vm = reactive({
    options: {} as PromptModalOptions,
    requestPending: false
})
const modal = useModalStore()
const props = defineProps<{
    options: PromptModalOptions,
    callback: ParamsCallback,
    close: EmptyCallback,
}>();

vm.options = props.options;

function cancel() {
    props.callback(null)
    modal.cancel()
}

function confirm() {
    vm.requestPending = true
    props.callback(vm.options.value)
    props.close()
}

</script>

<template>
    <div>
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" @click="cancel" v-if="vm.options.closeButton">
                <i class="fas fa-times"></i>
            </button>
            <h4 class="modal-title">
                {{ vm.options.title }}
            </h4>
        </div>
        <div class="modal-body">
            <div v-if="vm.options.inputType === 'select'">
                <select class="form-control" v-model="vm.options.value" required>
                    <option :value="null">--- Choose option ---</option>
                    <option :value="opt.value" v-for="(opt, idx) in vm.options.inputOptions" :key="idx">
                        {{ opt.text }}
                    </option>
                </select>
            </div>
            <div v-if="vm.options.inputType === 'input'">
                <input type="text" class="form-control" v-model="vm.options.value" required />
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn" :class="vm.options.buttons.cancel.className || ''" @click="cancel">
                {{ vm.options.buttons.cancel.label }}
            </button>
            <button class="btn" :class="vm.options.buttons.confirm.className || ''" @click="confirm"
                :disabled="vm.requestPending">{{ vm.options.buttons.confirm.label }}</button>
        </div>
    </div>
</template>